/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_TrademarksInputs */

const en_footer_trademarks = /** @type {(inputs: Footer_TrademarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All trademarks and copyrights on this site are owned by their respective owners.`)
};

const es_footer_trademarks = /** @type {(inputs: Footer_TrademarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las marcas comerciales y derechos de autor en este sitio son propiedad de sus respectivos propietarios.`)
};

/**
* | output |
* | --- |
* | "All trademarks and copyrights on this site are owned by their respective owners." |
*
* @param {Footer_TrademarksInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
const footer_trademarks = /** @type {((inputs?: Footer_TrademarksInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_TrademarksInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_trademarks(inputs)
	return en_footer_trademarks(inputs)
});
export { footer_trademarks as "footer.trademarks" }